/*
 * Brand page contents - My CPAP Shop
 *
 * Builds the "On this page" list from the headings the page actually has, so a
 * store owner editing a page in the admin never has to remember to update a
 * hand-typed list. Ids are generated here too, because content pasted into the
 * Shopify rich text editor has none.
 *
 * Runs in the theme editor as well: section:load fires when the section is
 * added or its settings change, and page content itself can be re-rendered
 * under it, so the list is rebuilt rather than assumed.
 */
(function () {
  'use strict';

  var SOURCE_SELECTOR = '.main-page-title + .rte, .article-template__content .rte';

  function slugify(text, used) {
    var base = text
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60);

    if (!base) base = 'section';

    var slug = base;
    var suffix = 2;
    while (used[slug]) {
      slug = base + '-' + suffix;
      suffix += 1;
    }
    used[slug] = true;

    return slug;
  }

  function build(nav) {
    var list = nav.querySelector('[data-brand-page-toc-list]');
    if (!list) return;

    var source = document.querySelector(SOURCE_SELECTOR);
    if (!source) {
      nav.hidden = true;
      return;
    }

    var headings = source.querySelectorAll('h2');
    var minimum = parseInt(nav.getAttribute('data-minimum'), 10);
    if (isNaN(minimum)) minimum = 3;

    if (headings.length < minimum) {
      nav.hidden = true;
      return;
    }

    var used = {};
    var fragment = document.createDocumentFragment();

    Array.prototype.forEach.call(headings, function (heading) {
      var label = (heading.textContent || '').trim();
      if (!label) return;

      if (!heading.id) heading.id = slugify(label, used);
      else used[heading.id] = true;

      var link = document.createElement('a');
      link.className = 'brand-page-toc__link';
      link.href = '#' + heading.id;
      link.textContent = label;

      var item = document.createElement('li');
      item.className = 'brand-page-toc__item';
      item.appendChild(link);
      fragment.appendChild(item);
    });

    if (!fragment.childNodes.length) {
      nav.hidden = true;
      return;
    }

    list.textContent = '';
    list.appendChild(fragment);
    nav.hidden = false;
  }

  function buildAll() {
    document.querySelectorAll('[data-brand-page-toc]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildAll);
  } else {
    buildAll();
  }

  document.addEventListener('shopify:section:load', buildAll);
})();
